module.exports = __webpack_public_path__ + "images/柏纳长图_04-4.jpg?v=81949847";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_04-4.jpg
 ** module id = 142
 ** module chunks = 1 2
 **/